// Kit / Shared Context
export const SET_LOOPBLOB = 'SET_LOOPBLOB';

// Sample Context
export const LOAD_SAMPLE = 'LOAD_SAMPLE';
export const EJECT_SAMPLE = 'EJECT_SAMPLE'
export const ADD_REGION = 'ADD_REGION';
export const REMOVE_REGION = 'REMOVE_REGION';
export const REMOVEALL_REGIONS = 'REMOVEALL_REGIONS';
export const SET_REGIONS = 'SET_REGIONS'
export const HOVER_REGION = 'HOVER_REGION';
export const CLEAR_HOVER = 'CLEAR_HOVER';
export const CLICK_REGION = 'CLICK_REGION';
export const CLEAR_CLICK = 'CLEAR_CLICK';
export const SET_RECORD = 'SET_RECORD';

// Loop Context
export const ADDTO_LOOPBANK = 'ADDTO_LOOPBANK';
export const REMOVEFROM_LOOPBANK = 'REMOVEFROM_LOOPBANK';
export const CALLUP_LOOP = 'CALLUP_LOOP';
export const ADDTO_SEQUENCE = 'ADDTO_SEQUENCE';
export const CLEAR_SEQUENCE = 'CLEAR_SEQUENCE';

// Help Context
export const HELP_MESSAGE = 'HELP_MESSAGE'
